import React from "react";
import { useNavigate } from "react-router-dom";
import { Activity, ArrowLeft, LifeBuoy, Mail, Clock, HelpCircle } from "lucide-react";

const FAQ = [
  { q: "How do I get an account?", a: "Accounts are created by your department administrator. If you need access, contact your admin or email us below and we'll help route your request." },
  { q: "I forgot my password.", a: "Your department administrator can reset your password from the Staff screen. Email us if you can't reach your admin." },
  { q: "How does auto-scheduling work?", a: "Admins can auto-generate a 12-hour Panama (2-2-3) rotation. The system balances CT, X-ray, and dual-certified coverage and flags conflicts automatically." },
  { q: "How do shift swaps work?", a: "Technologists request a swap with an eligible colleague; the other tech accepts or declines. Admins can also review requests." },
  { q: "How do I delete my account or data?", a: "Ask your department administrator to remove your account from the Staff screen, or email us and we will delete your account and associated personal data." },
  { q: "Are donations required?", a: "No. Donations are optional, processed securely by Stripe, and do not unlock or affect any app features." },
];

export default function Support() {
  const navigate = useNavigate();
  return (
    <div className="rs-grid-bg rs-scanlines min-h-screen text-white p-6 sm:p-10">
      <div className="max-w-3xl mx-auto relative z-[2] rs-fade-up">
        <button data-testid="support-back" onClick={() => navigate(-1)} className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm font-mono-rs uppercase mb-8">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>

        <div className="flex items-center gap-3 mb-2">
          <Activity className="w-7 h-7 text-[#D902EE] rs-text-glow-magenta" />
          <span className="font-mono-rs text-2xl font-bold tracking-tighter uppercase">
            Radio<span className="text-[#D902EE]">Shift</span>
          </span>
        </div>
        <div className="flex items-center gap-2 mb-8">
          <LifeBuoy className="w-5 h-5 text-[#00F0FF]" />
          <h1 className="font-mono-rs text-2xl uppercase tracking-wide">Support</h1>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          <a href="mailto:support@langleyradioshift.com" data-testid="support-email"
            className="bg-[#0F1219] border border-[#D902EE]/40 p-5 hover:border-[#D902EE] transition-all duration-300 block">
            <Mail className="w-5 h-5 text-[#D902EE] mb-3" />
            <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-1">Email us</div>
            <div className="font-mono-rs text-sm text-white break-all">support@langleyradioshift.com</div>
          </a>
          <div className="bg-[#0F1219] border border-slate-800 p-5">
            <Clock className="w-5 h-5 text-[#00F0FF] mb-3" />
            <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-1">Response time</div>
            <div className="font-mono-rs text-sm text-white">Within 1–2 business days</div>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <HelpCircle className="w-4 h-4 text-[#00F0FF]" />
          <h2 className="font-mono-rs text-sm uppercase tracking-[0.15em] text-[#00F0FF]">Frequently asked</h2>
        </div>
        <div className="space-y-5 mb-10">
          {FAQ.map((f) => (
            <div key={f.q} className="border-l-2 border-slate-700 pl-4">
              <div className="font-mono-rs text-sm text-white mb-1">{f.q}</div>
              <p className="text-sm text-slate-400 leading-relaxed">{f.a}</p>
            </div>
          ))}
        </div>

        <p className="text-xs text-slate-600 font-mono-rs">
          Still need help? Email support@langleyradioshift.com and our team will get back to you.
        </p>
      </div>
    </div>
  );
}
